import React from "react";

import { MdmObject, useGetObjectsByProjectQuery } from "gql/generated/types";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";

const Objects = () => {
  const projectId = useOutletContext<string>();
  const { data, loading } = useGetObjectsByProjectQuery({
    variables: { id: projectId },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const objectInfoBtn = (rowData: MdmObject) => (
    <Link to={`objects/${rowData.id}`} title="Object Info">
      <i className="pi pi-external-link" />
    </Link>
  );

  const columns: TableColumn<MdmObject>[] = [
    { field: "title", header: "Object Code", sortable: true, filter: true },
    {
      field: "address.fullAddress",
      header: "Address",
      sortable: true,
      filter: true,
    },
    { field: "tags", header: "Tags", body: rowData => rowData.tags.join(", ") },
    {
      header: "Actions",
      body: objectInfoBtn,
    },
  ];

  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmObjectsByProjectId as MdmObject[]}
        onToolbarBtnClick={() => navigate("objects/new")}
        searchFields={["title", "address", "tags"]}
        toolbarBtnLabel="Add Object"
        isLoading={loading}
      />
    </div>
  );
};

export default Objects;
